module.exports = __webpack_public_path__ + "img/WeChat.c3bdb6e9.png";